import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { TitleDetail } from '@/interfaces/title-details-graphql';

import { useI18n } from '@/helpers/composables/useI18n';
import { useLanguageStore } from '@/helpers/composables/useStores';
import { MonetizationType, UpcomingReleaseLabel } from '@/@types/graphql-types';
import {
	allowedGenericSpinLanguages,
	UpcomingReleaseForSpinningText,
} from '@/features/buybox/helpers/upcoming-helpers';
import UpcomingSpinningSegment from '@/components/details/spinning-text/UpcomingSpinningSegment.vue';
import { formattedReleaseDate } from '@/helpers/date-helper';


export default /*#__PURE__*/_defineComponent({
  __name: 'Cinema',
  props: {
    title: null,
    upcomingReleases: null
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail; upcomingReleases: UpcomingReleaseForSpinningText[] };



const { tc } = useI18n();
const { country, language } = useLanguageStore();

const titleName = computed(() => props.title.content.title);
const cinemaOffers = computed(() =>
	props.title.offers
		.filter(cur => cur.monetizationType === MonetizationType.Cinema)
		.map(el => formatPackageName(el.package.clearName, country.value))
		.join(', ')
);

const countryName = computed(() =>
	country.value === 'US' ? tc('WEBAPP_COUNTRY_THE_US') : tc(`WEBAPP_COUNTRY_${country.value}`)
);

const isAllowedGenericSpinLanguage = computed(() => allowedGenericSpinLanguages.includes(language.value));

const genericUpcomingRelease = computed(() =>
	// when there are no complete upcoming releases, there may be a generic upcoming release (either empty package, or imdbmeta scrape) where we can get the release date
	props.title.content.upcomingReleases?.find(
		el => el.releaseType === 'THEATRICAL' && (!el.package || ['imd', 'tmd'].includes(el.package?.shortName))
	)
);

const formattedDate = computed(() => {
	if (!genericUpcomingRelease.value) return null;
	return formattedReleaseDate(
		genericUpcomingRelease.value.releaseDate,
		genericUpcomingRelease.value.label,
		language.value,
		'long',
		country.value,
		true
	).heading;
});

const releaseLabelIsSeason = computed(
	() =>
		genericUpcomingRelease.value &&
		[
			UpcomingReleaseLabel.Autumn,
			UpcomingReleaseLabel.Winter,
			UpcomingReleaseLabel.Spring,
			UpcomingReleaseLabel.Summer,
		].includes(genericUpcomingRelease.value.label)
);

// Adding .com to Entradas Cinema Offer for spain as it sounds/read weird with only "Entradas"
const formatPackageName = (packageName: string, country: string) => {
	return country === 'ES' && packageName === 'Entradas' ? packageName + '.com' : packageName;
};

return { __sfc: true,props, tc, country, language, titleName, cinemaOffers, countryName, isAllowedGenericSpinLanguage, genericUpcomingRelease, formattedDate, releaseLabelIsSeason, formatPackageName, UpcomingReleaseLabel, UpcomingSpinningSegment }
}

})